export default __webpack_public_path__ + "static/product-3-9c3699c3f3df7f8540bec4b7a3463e14.jpg";